<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="删除图片"
    width="900px"
    :close-on-click-modal="false"
    @closed="resetState"
  >
    <el-row :gutter="16" class="delete-image-dialog">
      <el-col :span="12" class="left-pane">
        <el-tree
          ref="tree"
          :data="treeData"
          node-key="id"
          show-checkbox
          default-expand-all
          :props="defaultProps"
          @check-change="handleTreeCheck"
        >
          <span slot-scope="{ data }" class="tree-node">
            <span class="tree-node__label">{{ data.folderName }}</span>
            <template v-if="isLeafNode(data) && data.fileUrl">
              <el-image
                class="thumb-image"
                :src="data.fileUrl"
                fit="cover"
                @click.stop="handlePreview(data.id)"
              />
              <el-image
                :ref="`preview-${data.id}`"
                class="preview-image-trigger"
                :src="data.fileUrl"
                :preview-src-list="[data.fileUrl]"
              />
            </template>
          </span>
        </el-tree>
      </el-col>
      <el-col :span="12" class="right-pane">
        <el-checkbox-group v-model="checkedLeafIds" @change="handleLeafChange">
          <div v-for="item in checkedLeafNodes" :key="item.id" class="leaf-row">
            <el-checkbox :label="item.id">{{ item.folderName }}</el-checkbox>
            <template v-if="item.fileUrl">
              <el-image
                class="thumb-image"
                :src="item.fileUrl"
                fit="cover"
                @click.stop="handlePreview(item.id)"
              />
              <el-image
                :ref="`preview-${item.id}`"
                class="preview-image-trigger"
                :src="item.fileUrl"
                :preview-src-list="[item.fileUrl]"
              />
            </template>
          </div>
        </el-checkbox-group>
      </el-col>
    </el-row>
    <div slot="footer">
      <el-button size="mini" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SectionDeleteImageDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      checkedLeafIds: [],
      defaultProps: {
        children: 'children',
        label: 'folderName'
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    checkedLeafNodes () {
      const checkedMap = {}
      this.collectLeafNodes(this.treeData).forEach(item => {
        checkedMap[item.id] = item
      })
      return this.checkedLeafIds.map(id => checkedMap[id]).filter(Boolean)
    }
  },
  methods: {
    isLeafNode (node) {
      return !node.children || !node.children.length
    },
    collectLeafNodes (list = [], result = []) {
      list.forEach(item => {
        if (item.children && item.children.length) {
          this.collectLeafNodes(item.children, result)
        } else {
          result.push(item)
        }
      })
      return result
    },
    handleTreeCheck () {
      const checkedNodes = this.$refs.tree ? this.$refs.tree.getCheckedNodes() : []
      this.checkedLeafIds = checkedNodes.filter(item => !item.children || !item.children.length).map(item => item.id)
    },
    handleLeafChange (val) {
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedKeys(val)
        this.handleTreeCheck()
      }
    },
    handlePreview (id) {
      this.$nextTick(() => {
        const previewRef = this.$refs[`preview-${id}`]
        const previewInstance = Array.isArray(previewRef) ? previewRef[0] : previewRef
        const previewEl = previewInstance && previewInstance.$el
        const imageEl = previewEl && previewEl.querySelector('.el-image__inner')
        if (imageEl) {
          imageEl.click()
        }
      })
    },
    handleConfirm () {
      this.$emit('confirm', this.checkedLeafNodes)
      this.dialogVisible = false
    },
    resetState () {
      this.checkedLeafIds = []
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedKeys([])
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.delete-image-dialog
  min-height 360px

.left-pane,
.right-pane
  height 420px
  overflow auto
  border 1px solid #ebeef5
  border-radius 4px
  padding 12px
  box-sizing border-box

.leaf-row
  margin-bottom 8px
  display flex
  align-items center
  gap 8px

.tree-node
  width 100%
  display flex
  align-items center
  justify-content space-between
  gap 8px

.tree-node__label
  flex 1
  overflow hidden
  text-overflow ellipsis
  white-space nowrap

.thumb-image
  width 32px
  height 32px
  border-radius 4px
  border 1px solid #dcdfe6
  flex-shrink 0
  cursor pointer

.preview-image-trigger
  width 1px
  height 1px
  opacity 0
  overflow hidden
  position absolute
  pointer-events none
</style>
